import { IBookingApi } from './Interface/IBookingApi';
import { ApiService } from '@/services/ApiService';
import { BookingsDto } from '../types';

export default class BookingApi extends ApiService implements IBookingApi {
    async getBookings(): Promise<BookingsDto | undefined> {
        return await this.httpGet<BookingsDto>(`/api/travelplanner/v1.0/bookings/my`);
    }

    async cancelBooking(bookingId: string): Promise<BookingsDto | undefined> {
        return await this.httpPut<BookingsDto>(`/api/travelplanner/v1.0/bookings/${bookingId}/cancel`);
    }
}
